<template>
  <div class="text-video-container">
    <!-- 左侧文案区域 -->
    <div class="text-content">
      <div class="content-wrapper">
        <h2 class="title" v-if="computedTitle">{{ computedTitle }}</h2>
        <div class="description" v-html="computedDescription" ></div>

        <!-- 特点列表 -->
        <ul class="features" v-if="computedFeatures && computedFeatures.length > 0">
          <li v-for="(feature, index) in computedFeatures" :key="index" class="feature-item">
            <i class="fa fa-check-circle"></i>
            {{ feature }}
          </li>
        </ul>

        <!-- 按钮组 -->
        <div class="buttons" v-if="computedButtons && computedButtons.length > 0">
          <button
              v-for="(button, index) in computedButtons"
              :key="index"
              :class="['btn', button.type || 'primary']"
              @click="linkPage(index)"
          >
            {{ button.label }}
            <i :class="button.icon || 'fa-arrow-right'" class="ml-2"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- 右侧视频区域 -->
    <div class="video-content">
      <div class="video-wrapper">
        <!-- 视频播放器 -->
        <video-player
            :src="videos[0].src"
            :auto-play="false"
            :controls="true"
            :width="videos[0].width"
            :height="videos[0].height"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextVideoComponent',
  props: {
    // 允许父组件传递自定义标题，否则使用i18n默认值
    title: { type: String },
    // 允许父组件传递自定义描述，否则使用i18n默认值
    description: { type: String },
    videoUrl: { type: String, required: true },
    videos: { type: Array, required: true },
    poster: { type: String, default: '' },
    preload: { type: String, default: 'metadata' },
    videoType: { type: String, default: 'video/mp4' },
    // 允许父组件传递自定义特点列表，否则使用i18n默认值
    features: { type: Array },
    // 允许父组件传递自定义按钮，否则使用i18n默认值
    buttons: { type: Array }
  },
  data() {
    return { isPlaying: false, isHovering: false, showPlayButton: true };
  },
  computed: {
    // 标题：优先使用父组件传递的，否则使用i18n
    computedTitle() {
      return this.title || this.$t('textVideo.title');
    },
    // 描述：优先使用父组件传递的，否则使用i18n
    computedDescription() {
      return this.description || this.$t('textVideo.description');
    },
    // 特点列表：优先使用父组件传递的，否则使用i18n
    computedFeatures() {
      if (this.features && this.features.length > 0) {
        return this.features;
      }
      return [
        this.$t('textVideo.features.quality'),
        this.$t('textVideo.features.supplyChain'),
        this.$t('textVideo.features.design'),
        this.$t('textVideo.features.experience')
      ];
    },
    // 按钮：优先使用父组件传递的，否则使用i18n
    computedButtons() {
      if (this.buttons && this.buttons.length > 0) {
        return this.buttons;
      }
      return [
        {
          label: this.$t('textVideo.buttons.learnMore'),
          type: 'primary'
        },
        {
          label: this.$t('textVideo.buttons.contactUs'),
          type: 'secondary'
        }
      ];
    },
    playButtonIcon() {
      return this.isPlaying ? 'fa-pause' : 'fa-play';
    }
  },
  methods: {
    linkPage(flag){
      switch (flag){
        case 0: this.$router.push({ name: 'PdtList', params: { categoryId:0 } }); break;
        case 1: this.$router.push({ name: 'contactUs', params: { categoryId:0 } }); break;
      }
    },
    handlePlay() { this.isPlaying = true; this.showPlayButton = false; },
    handlePause() { this.isPlaying = false; this.showPlayButton = true; },
    handleEnded() { this.isPlaying = false; this.showPlayButton = true; }
  },
  mounted() {}
};
</script>

<style scoped>
/* 原有样式保持不变 */
.text-video-container {
  display: flex;
  justify-content: center;
  width: 80%;
  margin: 0 auto;
  max-width: 1500px;
  gap: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 30px 10px;
}

.text-content {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 2rem 6rem;
  background-color: #f8f9fa;
  position: relative;
  overflow: hidden;
}

.text-content::before {
  content: '';
  position: absolute;
  top: -100px;
  right: -100px;
  width: 200px;
  height: 200px;
  background-color: rgba(108, 99, 255, 0.1);
  border-radius: 50%;
}

.text-content::after {
  content: '';
  position: absolute;
  bottom: -150px;
  left: -150px;
  width: 300px;
  height: 300px;
  background-color: rgba(108, 99, 255, 0.05);
  border-radius: 50%;
}

.content-wrapper {
  position: relative;
  z-index: 10;
  max-width: 600px;
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #2d3748;
  line-height: 1.2;
}

.description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 2rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.features {
  list-style: none;
  padding: 0;
  margin-bottom: 3rem;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  color: #4a5568;
}

.feature-item i {
  color: lawngreen;
  margin-right: 0.75rem;
  font-size: 1.2rem;
}

.buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.btn {
  padding: 0.8rem 2rem;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn.primary {
  background-color: #409eff;
  color: white;
  box-shadow: 0 5px 15px rgba(108, 99, 255, 0.2);
}

.btn.primary:hover {
  background-color: #409eff;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(108, 99, 255, 0.3);
}

.btn.secondary {
  background-color: #ffffff;
  color: #409eff;
  border: 1px solid #409eff;
}

.btn.secondary:hover {
  background-color: #f8f9fa;
  transform: translateY(-2px);
}

.video-content {
  flex: 2.2;
  position: relative;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
}

.video-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  max-width: 100%;
}

.video-player {
  width: 100%;
  height: auto;
  object-fit: cover !important; /* 覆盖整个容器，裁切多余部分 */
  min-width: 100%; /* 防止宽度收缩 */
  min-height: 100%; /* 防止高度收缩 */
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.video-content:hover .video-overlay {
  opacity: 1;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba(108, 99, 255, 0.8);
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
}

.play-button:hover {
  background-color: rgba(108, 99, 255, 1);
  transform: translate(-50%, -50%) scale(1.1);
  box-shadow: 0 0 0 15px rgba(108, 99, 255, 0.3);
}

.play-button i {
  margin-left: 5px;
}

@media (max-width: 992px) {
  .text-video-container {
    flex-direction: column;
    width: 100%;
    gap: 30px;
    padding: 20px 0;
  }
  .text-content, .video-content {
    flex: none;
    width: 100%;
  }
  .text-content {
    padding: 3rem;
  }
  .title {
    font-size: 2rem;
  }
  .video-content {
    height: 400px;
  }
}

@media (max-width: 768px) {
  .text-content {
    padding: 1.5rem 1rem;
    width: 90%;
  }

  .description {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    font-size: 0.95rem;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }

  .text-content::before {
    top: -50px;
    right: -50px;
    width: 100px;
    height: 100px;

  }
  .text-content::after {
    bottom: -80px;
    left: -80px;
    width: 160px;
    height: 160px;
  }

  .content-wrapper {
    max-width: 100%;
    padding: 0 0.5rem;
    margin: 0;
  }

  .title {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .features {
    margin-bottom: 1.5rem;
  }
  .feature-item {
    font-size: 0.95rem;
    margin-bottom: 0.8rem;
  }
  .feature-item i {
    font-size: 1rem;
    margin-right: 0.5rem;
  }

  .buttons {
    gap: 0.8rem;
    justify-content: flex-start;
    padding: 0;
    margin: 0;
  }
  .btn {
    width: 100%;
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
    margin: 0;
  }

  .video-content {
    height: 220px;
  }

  .play-button {
    width: 50px;
    height: 50px;
    font-size: 1rem;
  }
}
</style>
